import generateLinkTag from "./generate_cookieconsent_compliant_link_tag";

generateLinkTag({
  url: "https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700,900",
});
